import React from 'react'
import ChargebackTemplate from '../ChargebacksTemplate/ChargebackTemplate'

const Lost = () => {
  return (
    <div>
      <ChargebackTemplate title='Lost' status="Lost"/>
    </div>
  )
}

export default Lost
